import { Check, UserCheck, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";
import { useApp } from "@/lib/i18n";
import { speakerColor } from "./transcriptUtils";

export const SpeakerSuggestions = ({ meeting, canWrite, onMeeting }) => {
  const { L } = useApp();
  const list = meeting.speaker_suggestions || [];
  if (!canWrite || !list.length) return null;
  const apply = async (speakers) => {
    try {
      const { data } = await api.post(`/meetings/${meeting.id}/speaker-suggestions/apply`, { speakers });
      onMeeting(data);
      toast.success(L("Nama pembicara dikemas kini", "Speaker names updated"));
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  const dismiss = async () => {
    try {
      await api.post(`/meetings/${meeting.id}/speaker-suggestions/dismiss`);
      onMeeting({ speaker_suggestions: [] });
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <div className="mt-4 rounded-xl border border-emerald-200 bg-emerald-50/60 p-4" data-testid="speaker-suggestions">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-sm font-semibold text-emerald-900"><UserCheck size={16} /> {L("AI mencadangkan nama pembicara — sila sahkan", "AI suggests speaker names — please confirm")}</p>
        <div className="flex gap-2">
          <Button size="sm" className="h-8 rounded-lg bg-emerald-600 hover:bg-emerald-700" onClick={() => apply(list.map((x) => x.speaker))} data-testid="apply-all-suggestions-btn"><Check size={14} className="mr-1" /> {L("Guna semua", "Apply all")}</Button>
          <Button size="sm" variant="ghost" className="h-8 rounded-lg" onClick={dismiss} data-testid="dismiss-suggestions-btn"><X size={14} className="mr-1" /> {L("Abaikan", "Dismiss")}</Button>
        </div>
      </div>
      <div className="mt-3 space-y-2">
        {list.map((x) => (
          <div key={x.speaker} className="flex flex-wrap items-center gap-3 rounded-lg bg-white p-2.5 text-sm" data-testid={`speaker-suggestion-${x.speaker}`}>
            <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${speakerColor(x.speaker)}`}>{meeting.speaker_names?.[String(x.speaker)] || `Pembicara ${x.speaker}`}</span>
            <span className="text-slate-400">→</span>
            <strong>{x.name}</strong>
            <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ${x.confidence === "high" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`}>{x.confidence === "high" ? L("Tinggi", "High") : L("Sederhana", "Medium")}</span>
            {x.evidence && <span className="min-w-0 flex-1 truncate text-xs italic text-slate-500">“{x.evidence}”</span>}
            <Button size="sm" variant="outline" className="ml-auto h-7 rounded-lg text-xs" onClick={() => apply([x.speaker])} data-testid={`apply-suggestion-${x.speaker}`}>{L("Guna", "Apply")}</Button>
          </div>
        ))}
      </div>
    </div>
  );
};
